import React, {Component} from 'react';
import classnames from 'classnames';
import getVideoId from 'get-video-id';
import { injectIntl } from 'react-intl';
import Resource from '../services/Resource';
import PrivateAPIResource from '../services/PrivateAPIResource';
import Vimeo from '@u-wave/react-vimeo';
import * as submitButtonActions from '../actions/submit/submitButtonActions';
import * as vimeoActions from '../actions/vimeoActions';
import VimeoUpload from '../../src/vimeo/vimeo-upload';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {messages} from  './common/Translations';
import '../../scss/vimeoUploader.scss';

const MAX_FILE_SIZE = 52428800;
const VIMEO_USER_NAME = 'FBG - Medlemmer';

class VimeoUploader extends React.Component {

    constructor(props) {
        super(props);
        this.upload             = this.upload.bind(this);
        this.handleFileSelect   = this.handleFileSelect.bind(this);
        this.updateProgress     = this.updateProgress.bind(this);
        this.submitUploading    = this.submitUploading.bind(this);
        this.deleteVideo        = this.deleteVideo.bind(this);
        this.onKeyPress         = this.onKeyPress.bind(this);

        this.state = {
            results: null,
            showProgressBar: false,
            progress: 0,
            files: null,
            videoReady: false,
            videoNotFound: false,
            videoFromOwnAccount: true,
            undefinedOwner: false,
        };
    }

    componentDidMount() {
        let videoId = this.props.vimeoId.input.value;
        if (videoId) {
            this.isVideoReady(videoId);
            this.getVimeoData(videoId);
            this.getVideosOwner(videoId).then(company => this.setState({undefinedOwner: !company}));
        }
    }

    componentWillReceiveProps(newProps) {
        const prevId = this.props.vimeoId.input.value;
        const currentId = newProps.vimeoId.input.value;

        if(currentId && currentId !== prevId) {
            this.getVimeoData(currentId);
        }
    }

    getVimeoData(id) {
        this.props.actions.getVimeoData(id)
            .then(data => {
                if(data.user.name == VIMEO_USER_NAME) {
                    this.props.vimeoName.input.onChange(data.name);
                    this.props.vimeoDescription.input.onChange(data.description);
                    this.setState({videoFromOwnAccount: true});
                }
                else {
                    this.props.vimeoName.input.onChange(null);
                    this.props.vimeoDescription.input.onChange(null);
                    this.setState({videoFromOwnAccount: false});
                }
            });
    }

    getFile(event) {
        let file = event.target.files[0];
        let reader = new FileReader();
        reader.onload = this.upload;
        reader.readAsDataURL(file);
    }

    upload(event) {
        this.setState({file: event.currentTarget.result});
        fetch(Resource.prefix() + 'video/create', {
            body: {
                file: event.currentTarget.result,
                size: event.currentTarget.result.size
            },
            method: 'POST',
            headers: {
                'Content-type': 'multipart/form-data',
            }
        }).then((response) => {
            console.log(response);
        })
    }

    handleFileSelect(e) {
        e.stopPropagation();
        e.preventDefault();

        let files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
//         console.log(e.target.files);
        let fileSize = files[0].size;
       if (fileSize > MAX_FILE_SIZE) {
        // if (fileSize > 100) {
            this.showMessage(<span><strong>Fejl</strong>: {this.props.intl.formatMessage(messages.videoTooLarge)}</span>, 'danger');
            return false;
        }

        this.setState({results: null, files});

        this.submitUploading(files);
    }

    showMessage(message, type) {
        this.setState({
            showProgressBar: false,
            results: <div className={'alert alert-' + (type || 'success')}>{message}</div>
        });
    }

    deleteVideo() {
        this.setState({videoReady: false, videoNotFound: false});
        return this.props.vimeoId.input.onChange(null);
    }

    updateProgress(progress) {
        this.setState({progress: Math.floor(progress * 100)});
    }

    submitUploading(files) {
        this.props.actions.showSubmitButtonSpinner();
        this.setState({showProgressBar: true});
        let file = null;
        if(files) {
            file = files[0];
        } else {
            file = this.state.files[0];
        }

        (new VimeoUpload({
            name: this.props.vimeoName.input.value,
            description: this.props.vimeoDescription.input.value,
            file,
            token: VIMEO_TOKEN,
            onError: (data) => {
                this.showMessage(<span><strong>Error: </strong>{JSON.parse(data).error}</span>, 'danger');
                this.props.actions.hideSubmitButtonSpinner();
            },
            onProgress: (data) => {
                this.updateProgress(data.loaded / data.total);
            },
            onComplete: (videoLink) => {
                let url = videoLink;
                let videoId = getVideoId(videoLink).id;
                this.props.vimeoId.input.onChange(videoId);
                this.props.actions.addVimeoId(videoId, this.props.companyId);
                this.showMessage(<span><strong>{this.props.intl.formatMessage(messages.successfulUpload)}</strong>: {this.props.intl.formatMessage(messages.checkUploadedVideo)}: <a href={url}>{url}</a></span>);
                this.props.actions.hideSubmitButtonSpinner();
            }
        })).upload();
    }

    getVideoLink() {
        let videoId = this.props.vimeoId.input.value;
        if(videoId) {
            return 'https://vimeo.com/' + videoId;
        }

        return '';
    }

    parseId(event) {
        let videoLink = event.target.value;

        if(videoLink.search('vimeo.com') < 0) {
            this.showMessage(<span><strong>Fejl</strong>: {this.props.intl.formatMessage(messages.onlyVimeoVideo)}</span>, 'danger');
            return this.props.vimeoId.input.onChange(null);
        }

        let result = getVideoId(videoLink);
        if (result.id !== undefined) {
            this.isVideoReady(result.id);
            this.getVideosOwner(result.id)
                .then(company => {
                    if(!company) {
                        this.setState({undefinedOwner: true});
                        this.props.vimeoId.input.onChange(result.id);
                    }
                    else if(company.id == this.props.companyId) {
                        this.setState({undefinedOwner: false});
                        this.props.vimeoId.input.onChange(result.id);
                    }
                    else {
                        return this.showMessage(
                            <span>
                                <strong>Fejl: </strong>{this.props.intl.formatMessage(messages.vimeoCompanyAccessError, {companyName: company.name})}
                            </span>,
                            'danger'
                        );
                    }
                });

            return;
        }

        return this.props.vimeoId.input.onChange(null);
    }

    renderDeleteButton(videoId) {
        if(this.state.videoReady || this.state.videoNotFound) {
            return (
                <div className="form-group row">
                    <div className="col-sm-10 offset-2">
                        <button type="button" className="btn btn-outline-danger waves-effect waves-light" onClick={this.deleteVideo}>Fjern video</button>
                    </div>
                </div>
            );
        } else {
            return false;
        }
    }

    isVideoReady(videoId) {
        this.getVideoData(videoId)
            .then((json) => {
                if(json.error) {
                    this.setState({
                        videoNotFound: true,
                    });
                } else {
                    let videoReady = json.status === "available";
                    this.setState({
                        videoReady,
                    });
                }
            });
    }

    async getVideoData(videoId) {
        return await fetch(`https://api.vimeo.com/videos/${videoId}`, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer '+ VIMEO_TOKEN,
            },
        }).then(response => {
            return response.json();
        }).catch(error => {
            console.log(error);
        });
    }

    async getVideosOwner(videoId) {
        const vimeoData = await PrivateAPIResource.get('vimeos', videoId);
        return vimeoData.company;
    }

    onKeyPress() {
        this.showMessage(<span><strong>Omsorg</strong>: {this.props.intl.formatMessage(messages.inputNotAvailable)}</span>, 'warning');
    }

    renderFileUploader() {
        let file = null;
        let buttonName = 'Vælg video...';

        if(this.state.files) {
            file = this.state.files[0];
            if (file !== undefined) {
                buttonName = file.name;
            }
        }

        return (
            <div>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label"><b>Video</b></label>
                    <div className="col-sm-8">
                        <div id="progress-container" className={classnames('progress', 'mb-3', {'d-none': !this.state.showProgressBar})}>
                            <div
                                id="progress"
                                className={classnames('progress-bar', 'progress-bar-info', 'progress-bar-striped', 'active')} role="progressbar" style={{width: `${this.state.progress}%`}}>&nbsp;{this.state.progress}%</div>
                        </div>
                        <input readOnly={Boolean(file)}
                               className="form-control mb-3"
                               type="text"
                               placeholder="http://"
                               onKeyPress={this.onKeyPress}
                               disabled={this.state.showProgressBar}
                               value={this.getVideoLink()}
                               onChange={event => this.parseId(event)}/>
                    </div>
                    <div className="col-sm-2">
                        {/*<div id="drop_zone">Drop Files Here</div>
                                 <br/>*/}
                        <label className="btn btn-primary waves-effect waves-light clickable btn-m vimeo-button" hidden={this.state.progress !== 0}>
                            {buttonName} <input id="browse" type="file" accept='video/*' className="d-none" onChange={this.handleFileSelect}/>
                        </label>
                    </div>
                </div>

                <div className="form-group row">
                    <div className="col-md-10 offset-2">
                        <div id="results">{this.state.results}</div>
                    </div>
                </div>
            </div>
        );
    }

    renderTextFields() {
        let {vimeoName, vimeoDescription} = this.props;
        const canChangeMeta = this.state.videoFromOwnAccount && !this.state.undefinedOwner;

        return (
            <div className="form-group row">
                <div className="col-sm-2"></div>
                <div className="col-sm-10">
                    <input
                        type="text"
                        placeholder={this.props.intl.formatMessage(messages.vindeoName)}
                        className="form-control mb-3"
                        label={this.props.intl.formatMessage(messages.name)}
                        disabled={!canChangeMeta}
                        onChange={vimeoName.input.onChange}
                        value={vimeoName.input.value}
                    />
                    <textarea
                        type="text"
                        className="form-control mb-3"
                        label={this.props.intl.formatMessage(messages.description)}
                        onChange={vimeoDescription.input.onChange}
                        disabled={!canChangeMeta}
                        value={vimeoDescription.input.value}
                    />
                </div>

            </div>
        );
    }

    renderVimeoPlayer() {
        let videoId = this.props.vimeoId.input.value;

        if(this.state.videoReady && !this.state.videoNotFound) {
            return (
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">Eksempel</label>
                    <div className="col-sm-5">
                        <Vimeo
                            video={videoId}
                        />
                    </div>
                </div>
            )
        } else if(this.state.videoNotFound) {
            return (
                <div className="form-group row">
                    <div className="col-sm-10 offset-2">
                        <div className="alert alert-danger" role="alert">
                            {this.props.intl.formatMessage(messages.videoNotFound)}
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="form-group row">
                    <div className="col-sm-10 offset-2">
                        <div className="alert alert-warning" role="alert">
                            {this.props.intl.formatMessage(messages.videoPreparing)}
                        </div>
                    </div>
                </div>
            );
        }
    }

    render() {
        let videoId = this.props.vimeoId.input.value;
        if (!videoId) {
            return (
                <div>
                    {this.renderFileUploader()}
                    {this.renderTextFields()}
                </div>
            );
        } else {
            return (
                <div>
                    {this.renderVimeoPlayer()}
                    {this.renderTextFields()}
                    {this.renderDeleteButton(videoId)}
                </div>
            );
        }
    }

}

function mapStateToProps(state, ownProps) {
    let companyId;

    if(ownProps.companyId) {
        companyId = ownProps.companyId;
    }
    else if(state.user.company) {
        companyId = state.user.company.id;
    }

    return {
        companyId: companyId,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                submitButtonActions,
                vimeoActions,
            ), dispatch)
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(VimeoUploader));


// WEBPACK FOOTER //
// ./web/src/components/VimeoUploader.jsx